"use client";

import { SWRConfig } from "swr";
import { ReactNode } from "react";

interface SWRProviderProps {
  children: ReactNode;
}

// 默认的 fetcher
const defaultFetcher = async (url: string) => {
  const res = await fetch(url);
  if (!res.ok) {
    const error = new Error("An error occurred while fetching the data.");
    throw error;
  }
  return res.json();
};

export function SWRProvider({ children }: SWRProviderProps) {
  return (
    <SWRConfig
      value={{
        fetcher: defaultFetcher,
        // 全局缓存配置 - 这些数据不经常变化，使用激进的缓存策略
        revalidateOnFocus: false, // 窗口获得焦点时不重新验证
        revalidateOnReconnect: false, // 重新连接时不重新验证
        revalidateIfStale: false, // 如果数据过期不自动重新验证
        dedupingInterval: 300000, // 5分钟内相同请求去重
        focusThrottleInterval: 300000, // 5分钟内 focus 事件节流
        errorRetryCount: 3, // 错误重试次数
        shouldRetryOnError: true,
        // 注意：SWR 的默认内存缓存会在页面导航时保持数据
        // 不使用 localStorage 持久化，避免 hydration 问题
      }}
    >
      {children}
    </SWRConfig>
  );
}
